function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Helper functions to handle objects implementing the modapp LocaleString interface.
 */
function hasMethod(v, m) {
  return v && _typeof(v) === 'object' && typeof v[m] === 'function';
}

function hasOnOff(v) {
  return hasMethod(v, 'on') && hasMethod(v, 'off');
}

export function translate(v) {
  if (hasMethod(v, 'translate')) {
    return v.translate();
  }

  return String(v);
}
;
export function onLocaleUpdate(v, cb) {
  if (hasOnOff(v)) {
    v.on('localeUpdate', cb);
  }
}
export function offLocaleUpdate(v, cb) {
  if (hasOnOff(v)) {
    v.off('localeUpdate', cb);
  }
}